/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_No_Display_Settings_MessageInputs */

const en_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No valid display settings provided to update`)
};

const fr_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun parametre d'affichage valide a mettre a jour`)
};

const de_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine gültigen Anzeigeeinstellungen für ein Update angegeben.`)
};

const it_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna impostazione di visualizzazione valida fornita per l'aggiornamento`)
};

const ru_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не предоставлены допустимые параметры отображения для обновления.`)
};

const es_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se proporcionaron configuraciones de pantalla válidas para actualizar`)
};

const zh_cn2_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未提供有效的显示设置以进行更新`)
};

const ja_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新するための有効な表示設定が指定されていません`)
};

const hi_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट करने के लिए कोई वैध डिस्प्ले सेटिंग प्रदान नहीं की गई है।`)
};

const pt_pt2_iframe_remote_no_display_settings_message = /** @type {(inputs: Iframe_Remote_No_Display_Settings_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma configuração de exibição válida foi fornecida para atualização.`)
};

/**
* | output |
* | --- |
* | "No valid display settings provided to update" |
*
* @param {Iframe_Remote_No_Display_Settings_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_no_display_settings_message = /** @type {((inputs?: Iframe_Remote_No_Display_Settings_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_No_Display_Settings_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_no_display_settings_message(inputs)
	if (locale === "de") return de_iframe_remote_no_display_settings_message(inputs)
	if (locale === "it") return it_iframe_remote_no_display_settings_message(inputs)
	if (locale === "ru") return ru_iframe_remote_no_display_settings_message(inputs)
	if (locale === "es") return es_iframe_remote_no_display_settings_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_no_display_settings_message(inputs)
	if (locale === "ja") return ja_iframe_remote_no_display_settings_message(inputs)
	if (locale === "hi") return hi_iframe_remote_no_display_settings_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_no_display_settings_message(inputs)
	return en_iframe_remote_no_display_settings_message(inputs)
});